type ResponseLike = { status?: number; body?: unknown } | undefined;

export interface StorageRefusal {
  status?: number;
  code?: string;
}

const FILE_NOT_RECEIVED_AS_DECLARED = new Set(["EntityTooSmall", "EntityTooLarge", "IncompleteBody"]);

const codeIn = (body: unknown): string | undefined => {
  const text = typeof body === "string" ? body : undefined;
  return text?.match(/<Code>([^<]+)<\/Code>/)?.[1];
};

export const storageRefusal = (error: unknown, response?: ResponseLike): StorageRefusal => {
  // @uppy/aws-s3 rejects a non-2xx answer with Error("Non 2xx") and the XMLHttpRequest as `source`.
  const source = (error as { source?: { status?: number; responseText?: unknown } } | undefined)?.source;
  return {
    status: response?.status ?? source?.status,
    code: codeIn(response?.body) ?? codeIn(source?.responseText),
  };
};

export const fileWasNotReceivedAsDeclared = (refusal: StorageRefusal): boolean =>
  refusal.code !== undefined && FILE_NOT_RECEIVED_AS_DECLARED.has(refusal.code);
